// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"241":"62f0fb0d","421":"bf35ec56"}[chunkId] + ".chunk.css");